import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../services/authentication.service';
import {NavigationEnd, Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {NavService} from './nav.service';
import {SidebarOptions} from './nav.interfaces';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {
    user: any = {username: ''};

    adminUrl = environment.adminUrl;

    sidebarOptions: SidebarOptions = {title: '', entries: [], nodeClass: ''};

    active = '';

    constructor(private authService: AuthenticationService,
                private router: Router,
                private navService: NavService,
                private cdRef: ChangeDetectorRef) {
    }

    logout() {
        this.authService.logout();
        this.router.navigate(['/ingresar']);
    }

    routerProject() {
        if (this.active !== 'project') {
            this.router.navigate(['/crear-proyecto', {step: 1}]);
        }
    }

    routerFolders() {
        if (this.active !== 'folders') {
            this.router.navigate(['/carpetas']);
        }
    }

    routerProfiles() {
        if (this.active !== 'profiles') {
            this.router.navigate(['/perfiles']);
        }
    }

    ngOnInit() {
        this.authService.getUserInfo().subscribe( result => {}, error => {
            this.authService.logout();
            this.router.navigate(['/ingresar']);
          }
        );

        const storedUser = this.authService.getCurrentUser();
        if (storedUser !== null) {
            this.user = storedUser;
        }

        this.navService.sidebarOptions$.subscribe(options => {
            this.sidebarOptions = options;
            this.cdRef.detectChanges();
        });
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (event.url.indexOf('carpetas') >= 0 || this.router.url.indexOf('carpetas') >= 0) {
                    this.active = 'folders';
                }
                if (event.url.indexOf('proyecto') >= 0 || this.router.url.indexOf('proyecto') >= 0) {
                    this.active = 'project';
                }
                if (event.url.indexOf('perfiles') >= 0 || this.router.url.indexOf('perfiles') >= 0) {
                    this.active = 'profiles';
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/_shared/nav/nav.component.ts